import React from 'react';
import SectionWrapper from '../atoms/SectionWrapper';
import { TableProps } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import Filters from './Filters';
import '../Home/styles.css';
import { setFilters, useDispute } from '../../store/slices/disputeSlice';
import { useDispatch } from 'react-redux';
import {
  useGetDisputeListQuery,
  useMoveToArbirationMutation,
} from '../../store/services/disputeService';
import { useNavigate } from 'react-router-dom';
import TableWrapper from '../atoms/TableWrapper';
import CustomTable from '../atoms/CustomTable';

interface DataType {
  id: number;
  reason: string;
  customerType: string;
  requesterName: string;
  requestId: string;
  dateCreated: string;
  status: string;
}

const RequestsTable = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const filters = useDispute();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    data: DisputeList,
    isLoading,
    isFetching,
  } = useGetDisputeListQuery(filters, {
    refetchOnMountOrArgChange: true,
  });

  const [moveToArbitration] = useMoveToArbirationMutation();

  const columns: TableProps<DataType>['columns'] = [
    {
      title: t('dispute.disputeId'),
      dataIndex: 'disputeId',
      key: 'disputeId',
    },
    {
      title: t('dispute.orderId'),
      dataIndex: 'orderId',
      key: 'orderId',
      render: (val) => val || '-',
    },
    {
      title: t('dispute.requesterName'),
      dataIndex: 'requesterName',
      key: 'requesterName',
      render: (val) => val || '-',
    },

    {
      title: t('dispute.userType'),
      key: 'userType',
      dataIndex: 'userType',
    },
    {
      title: t('dispute.status'),
      key: 'status',
      dataIndex: 'status',
      render: (value) => value.name,
    },
    {
      title: t('dispute.reason'),
      dataIndex: 'reason',
      key: 'reason',
    },
    {
      title: t('dispute.dateCreated'),
      key: 'dateCreated',
      dataIndex: 'dateCreated',
      render: (value, TABLE) => {
        return (
          <p>
            {dayjs(value).isValid() ? dayjs(value).format('DD MMMM YYYY') : '-'}
          </p>
        );
      },
    },
  ];

  dayjs.locale(language);

  return (
    <SectionWrapper
      title={t('dispute.title')}
      desc={t('dispute.subTitle')}
      whiteBgChildren
    >
      <TableWrapper
        filters={<Filters />}
        title={t('dispute.title')}
        subTitle={t('dispute.subTitle')}
      >
        <CustomTable
          loading={isLoading || isFetching}
          columns={columns}
          dataSource={DisputeList?.payload?.content?.map((item) => ({
            requestId: item?.requestId,
            id: item?.id,
            disputeId: item.serial,
            requesterName: item?.requesterName,
            orderId: item.orderId,
            reason: item?.reason,
            userType: item?.userType,
            status: item?.status,
            dateCreated: item?.requestedAt,
          })) ?? []}
          currentPage={filters?.page}
          pageSize={filters?.limit}
          totalElements={DisputeList?.payload?.totalElements ?? 0}
          onPageChange={(page, pageSize) => {
            dispatch(
              setFilters({
                page: page - 1,
                limit: pageSize,
              })
            );
          }}
          onRowClick={async (_e, record) => {
            if (record?.status?.code === 'ADMIN_NEW')
              await moveToArbitration({ disputeId: record.id });

            navigate(`${record?.id}`);
          }}
        />
      </TableWrapper>
    </SectionWrapper>
  );
};

export default RequestsTable;
